module.exports = __webpack_public_path__ + "static/media/OurStory-YellowCircle.b87305fe.svg";